module.exports = __webpack_public_path__ + "media/images/city/034-mosque-of-cordoba-6d0d1f8134b29187c1d422d2d281db08.svg";